import * as yup from 'yup'

import { IModelBaseModel } from '../model-base/model-base.interface'
import { ModelBaseModel } from '../model-base/model-base.model'

import { IScoreCardInterface } from './score-cards.interface'

export class ScoreCardModel extends ModelBaseModel<IScoreCardInterface> implements IModelBaseModel {
  public v: IScoreCardInterface['v']
  public id: IScoreCardInterface['id']

  public owner: IScoreCardInterface['owner']
  public isPublic: IScoreCardInterface['isPublic']

  public name: IScoreCardInterface['name']
  public type: IScoreCardInterface['type']
  public furtherRemarks: IScoreCardInterface['furtherRemarks']

  public sections: IScoreCardInterface['sections']

  public showJumpOff: IScoreCardInterface['showJumpOff']
  public isWithdrew: IScoreCardInterface['isWithdrew']
  public fenceHeight: IScoreCardInterface['fenceHeight']

  public created: IScoreCardInterface['created']
  public modified: IScoreCardInterface['modified']

  public constructor(obj?: IScoreCardInterface) {
    super()
    this.v = obj?.v ?? 1
    this.id = obj?.id ?? null

    this.owner = obj?.owner ?? null
    this.isPublic = obj?.isPublic ?? false

    this.name = obj?.name ?? ''
    this.type = obj?.type ?? null
    this.furtherRemarks = obj?.furtherRemarks ?? ''

    this.sections = obj?.sections ?? []

    this.showJumpOff = obj?.showJumpOff ?? false
    this.isWithdrew = obj?.isWithdrew ?? false
    this.fenceHeight = obj?.fenceHeight ?? ''

    this.created = this.utcTimestamp({
      key: 'created',
      isTimestamp: true,
      value: obj?.created ?? new Date().toString(),
    })

    this.modified = this.utcTimestamp({
      key: 'modified',
      isTimestamp: true,
      changeOnUpdate: true,
      value: obj?.modified ?? new Date().toString(),
    })
  }

  static fromFirestoreDoc(doc: any, scoreCard?: number) {
    return new ScoreCardModel({
      id: doc.id,
      scoreCard,
      ...doc.data(),
    })
  }

  static validationSchema() {
    return yup.object().shape({
      name: yup.string().required('Name is required'),
      furtherRemarks: yup.string(),
      fenceHeight: yup.string().required('Fence height is required'),
      sections: yup.array().of(
        yup.object().shape({
          name: yup.string().required('Name is required'),
          rows: yup.array().of(
            yup.object().shape({
              description: yup.string().required('Name is required'),
            })
          ),
        })
      ),
    })
  }
}
